import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfileApiCall } from '@/services/api'
import { updateProfileFields } from "@/store/slices/profile/profileSlice"
import { RootState } from '@/store/index';
import { useEffect, useState } from 'react';
import { setProfileStepNo } from "@/store/slices/profile/profileStepNo"
import { getCurrentDate, getRegionsByCountryValue } from "@/utils"

import GoBackModal from '@/pages/profile/sections/addressDetails/components/goBackModal'

import AddressDetailsView from './view'

export default function AddressDetails() {
    /*
        profileStepNo = 2 : stay on the page
        profileStepNo = 1 : open popup
        profileStepNo = 3 : redirect to timeline via clicking submit btn
    */
    const { common } = useLocalTranslation();
    const dispatch = useDispatch()

    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);

    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)
    const [errMsg, setErrMsg] = useState("")
    const [flatHouseNumber, setFlatHouseNumber] = useState("")
    const [buildingName, setbuildingName] = useState("")
    const [colonyName, setColonyName] = useState("")
    const [areaName, setAreaName] = useState("")
    const [landmark, setLandmark] = useState("")
    const [pincode, setPincode] = useState("")
    const [city, setCity] = useState("")
    const [country, setCountry] = useState<any>(null)
    const [allStates, setAllStates] = useState<any>(null)
    const [selectedState, setSelectedState] = useState<any>(null)
    const [addressAcknowledged, setAddressAcknowledged] = useState(false)
    const [showModal, setShowModal] = useState(false);

    const currentDateISO = getCurrentDate()


    useEffect(() => {
        updateBasicDetails()
    }, [profileDetails])


    useEffect(() => {
        dispatch(setProfileStepNo(2))
    }, [])

    useEffect(() => {
        handlePopup()
    }, [profileStepNo])


    const updateBasicDetails = () => {
        if (profileDetails.flatHouseNumber) {
            setFlatHouseNumber(profileDetails.flatHouseNumber)
        }
        if (profileDetails.buildingName) {
            setbuildingName(profileDetails.buildingName)
        }
        if (profileDetails.colonyName) {
            setColonyName(profileDetails.colonyName)
        }
        if (profileDetails.areaName) {
            setAreaName(profileDetails.areaName)
        }
        if (profileDetails.landmark) {
            setLandmark(profileDetails.landmark)
        }
        if (profileDetails.pincode) {
            setPincode(profileDetails.pincode)
        }
        if (profileDetails.city) {
            setCity(profileDetails.city)
        }
        if (profileDetails.state) {
            const stateObj = {
                value: profileDetails.state,
                label: profileDetails.state,
            }
            setSelectedState(stateObj)
        }
        if (profileDetails.country) {
            const countryObj = {
                value: profileDetails.country,
                label: profileDetails.country,
            }
            setCountry(countryObj)
            const regions = getRegionsByCountryValue(profileDetails.country)
            if (regions) {
                setAllStates(regions)
            }
        }
        if (profileDetails.addressAcknowledged) {
            setAddressAcknowledged(profileDetails.addressAcknowledged)
        }
    }


    const handlePopup = () => {
        if (profileStepNo === 1) {
            handleOpenModal()
        }
    }


    const handleInputChange = (e: any, source: string) => {
        setErrMsg('')
        const val = e.target.value
        if (source === "flatHouseNumber") {
            setFlatHouseNumber(val)
        } else if (source === "buildingName") {
            setbuildingName(val)
        } else if (source === "colonyName") {
            setColonyName(val)
        } else if (source === "areaName") {
            setAreaName(val)
        } else if (source === "landmark") {
            setLandmark(val)
        } else if (source === "pincode") {
            setPincode(val)
        } else if (source === "city") {
            setCity(val)
        } else if (source === "state") {
            const stateObj = {
                value: val,
                label: val
            }
            setSelectedState(stateObj)
        } else if (source === "country") {
            const countryObj = {
                value: val,
                label: val
            }
            setCountry(countryObj)
            const regions = getRegionsByCountryValue(val)
            if (regions) {
                setAllStates(regions)
                setSelectedState(null)
            }
        }

    }

    const handleOnCheckBoxChanged = (e: any, source: string) => {
        const val = e.target.checked
        if (source === "addressAcknowledged") {
            setAddressAcknowledged(val)
        }
    }

    const handleSubmit = (source: string) => {
        setErrMsg('')
        setIsSubmitBtnLoading(true)

        let tempState = ""
        let tempCountry = ""
        if (selectedState && selectedState.value) {
            tempState = selectedState.value
        }
        if (country && country.value) {
            tempCountry = country.value
        }

        if (flatHouseNumber !== "" && colonyName !== ""
            && areaName !== "" && pincode !== ""
            && city !== ""
            && addressAcknowledged
            && tempState !== ""
            && tempCountry !== "") {
            if (pincode.toString().length !== 6) {
                setErrMsg(common.statusText.pingCodeErr)
                setIsSubmitBtnLoading(false)
                window.scrollTo(0, 0);
            } else {
                const updatedFields = {
                    flatHouseNumber: flatHouseNumber,
                    buildingName: buildingName,
                    colonyName: colonyName,
                    areaName: areaName,
                    landmark: landmark,
                    pincode: pincode,
                    city: city,
                    country: tempCountry,
                    state: tempState,
                    addressAcknowledged: addressAcknowledged,
                    lastAddressUpdatedAt: currentDateISO
                }
                handleSubmit3(updatedFields)
            }
        } else {
            setShowModal(false)
            dispatch(setProfileStepNo(2))
            if (flatHouseNumber === "" || colonyName === ""
                || areaName === "" || pincode === ""
                || city === ""
                || tempState === ""
                || tempCountry === "") {
                setErrMsg(common.statusText.pleaseGiveInput3)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput4)
            }
            setIsSubmitBtnLoading(false)
            window.scrollTo(0, 0);
        }
    }


    const handleSubmit3 = async (updatedFields: any) => {
        const fieldsToUpdate: any = {};
        let anyFieldChanged = false;
        let anyValueEmpty = false
        // debugger
        for (const source in updatedFields) {
            if (Object.prototype.hasOwnProperty.call(updatedFields, source)) {
                const newValue = updatedFields[source];
                const currentValue = profileDetails[source];
                if (newValue === "") {
                    anyValueEmpty = true
                }
                if (newValue !== "" && newValue !== currentValue) {
                    fieldsToUpdate[source] = newValue;
                    anyFieldChanged = true;
                }
            }
        }

        if (Object.keys(fieldsToUpdate).length > 0) {
            const updateUserProfileApiCallStatus = await updateUserProfileApiCall(fieldsToUpdate);
            // debugger
            if (updateUserProfileApiCallStatus.status) {
                dispatch(setProfileStepNo(3));
                dispatch(updateProfileFields(fieldsToUpdate));
            } else {
                dispatch(setProfileStepNo(2))
                if (updateUserProfileApiCallStatus.data) {
                    setErrMsg(updateUserProfileApiCallStatus.data);
                } else {
                    setErrMsg(common.statusText.issueInUpdating);
                }
                window.scrollTo(0, 0);
            }
        } else {
            if (anyValueEmpty) {
                setErrMsg(common.statusText.pleaseGiveInput2);
            }
            dispatch(setProfileStepNo(3));
        }

        setIsSubmitBtnLoading(false);
        setShowModal(false)
    };


    const handleOpenModal = () => {
        setShowModal(true)
    };
    const handleCloseModal = (status: string) => {
        if (status === "discard") {
            setShowModal(false)
            dispatch(setProfileStepNo(3))
        } else if (status === "saveAndClose") {
            handleSubmit('legalInfo')
        } else {
            setShowModal(false)
            dispatch(setProfileStepNo(2))
        }

    }


    return (
        <>
            <AddressDetailsView
                errMsg={errMsg}
                flatHouseNumber={flatHouseNumber}
                buildingName={buildingName}
                colonyName={colonyName}
                areaName={areaName}
                landmark={landmark}
                pincode={pincode}
                city={city}
                addressAcknowledged={addressAcknowledged}
                isSubmitBtnLoading={isSubmitBtnLoading}
                allStates={allStates}
                selectedState={selectedState}
                country={country}
                handleInputChange={handleInputChange}
                handleOnCheckBoxChanged={handleOnCheckBoxChanged}
                handleSubmit={handleSubmit}
            />


            <GoBackModal
                show={showModal}
                handleClose={handleCloseModal}
                isSubmitBtnLoading={isSubmitBtnLoading}
            />
        </>
    );
}
